import React, {
	useCallback, useEffect, useState
}from 'react'
import {
	Tooltip, Modal, Form, Input
}from 'antd'
import {
	useDispatch, useSelector
}from 'react-redux'
import {
	messageActions
}from '../../../Messages/store/actions'
import {
	Link
}from 'react-router-dom'
import 'antd/lib/tooltip/style/index.css'
import CustomButton from "../../../../components/ButtonCustom"
import Notifications from "../../../../helpers/Notifications"
import Attach from '../../../../../public/paper-clip.svg'
import i18n from '../../localization'
import i18nGlobal from '../../../../localization'
import UploadFile from "../../../../containers/UploadFile"
import './style.css'

const SendMessageFromList = ({
	reOrgAppeal, isRu
}) => {
	const { user, systemEnvironment } = useSelector((state) => state.userReducer)
	const { getSending, getLoadingSend } = useSelector((state) => state.messageReducer)
	const [form] = Form.useForm()
	const dispatch = useDispatch()
	const [visible, setVisible] = useState(false)

	const sendMessage = useCallback((params) => {
		dispatch(messageActions.sendMessage(params))
	}, [dispatch])

	const setRedirectUser = useCallback((redirectUser) => {
		dispatch(messageActions.setRedirectUser({
			redirectUser: redirectUser
		}))
	}, [dispatch])

	const normFile = (e) => {
		if (Array.isArray(e))
			return e
		return e && e.fileList
	}

	useEffect(() => {
		if (getSending){
			setVisible(false)
			Notifications.successNotice(i18n.sendMessageSuccess[isRu])
			dispatch(messageActions.clear())
			form.resetFields()
		}
	}, [getSending])

	function showModal(){
		setVisible(true)
	}

	function handleCancel(){
		form.resetFields()
		setVisible(false)
	}

	function getLabel(){
		function getName(){
			const name = `${ (reOrgAppeal.appeal.applicantLastName?.trim() ?? "") } ${ (reOrgAppeal.appeal.applicantFirstName?.trim() ?? "") } ${ (reOrgAppeal.appeal.applicantMiddleName?.trim() ?? "") }`.trim()
			const nameCreator = name ? name : (reOrgAppeal.appeal.orgCreator ? i18n.reOrgUser[isRu] : i18n.user[isRu])
			return (
				<Link
					to="/messages"
					onClick={ () => setRedirectUser(reOrgAppeal.appeal.creatorId) }
				>
					<strong title={ i18n.linkLabel[isRu] }>
						{ nameCreator }
					</strong>
				</Link>
			)
		}
		return (
			<div style={ { display: "inline-block" } }>
				<span>
					{ i18n.sendMessageFor[isRu] }
				</span>
				{
					reOrgAppeal.appeal.orgCreator ? (
						<Tooltip
							placement="top"
							title={ (isRu || !reOrgAppeal.appeal.orgCreator.fullNameBel ? reOrgAppeal.appeal.orgCreator.fullName : reOrgAppeal.appeal.orgCreator.fullNameBel) }
						>
							{ getName() }
						</Tooltip>
					) : (
						getName()
					)
				}
			</div>
		)
	}

	const onFinish = values => {
		const data = new FormData()
		values["messageFiles"]?.forEach((src) => {
			data.append("Files", src.originFileObj)
		})
		if (values["messageText"]?.trim())
			data.append("Text", values["messageText"].trim())
		data.append('Sender', user.id)
		data.append('Recipient', reOrgAppeal.appeal.creatorId)
		data.append('Initiator', user.id),
		data.append('AppealId', reOrgAppeal.id),
		sendMessage(data)
	}

	return (
		<>
			{((user.reOrg) && (reOrgAppeal.appeal.creatorId) && (reOrgAppeal.appeal.creatorId != "00000000-0000-0000-0000-000000000000") && (reOrgAppeal.reOrgId == user.reOrg.id) && (user.id != reOrgAppeal.appeal.creatorId)) ? (
					<>
						<Modal
							destroyOnClose
							className="send-message-form"
							footer={ null }
							title={ i18n.sendMessageTo[isRu] }
							visible={ visible }
							width={ 800 }
							onCancel={ handleCancel }
						>
							<Form
								form={ form }
								layout="vertical"
								onFinish={ onFinish }
							>
								<Form.Item
									noStyle
									shouldUpdate
								>
									{ () => {
										return 	(
											<Form.Item
												label={ getLabel() }
												name="messageText"
												style={ { marginBottom: form.getFieldValue("messageFiles")?.length ? 0 : 24 } }
											>
												<span className="ant-input-affix-wrapper">
													<Tooltip title={ i18nGlobal.downloadFileRulesInfo[isRu].format(systemEnvironment.maxFileSize / 1024 / 1024) }>
														<span className="ant-input-prefix">
															<a
																title={ i18n.attachFiles[isRu] }
																onClick={ () => {
																	document.getElementById("attachMessageFiles").click()
																} }
															>
																<img
																	className="verticalMiddle"
																	src={ Attach }
																/>
															</a>
														</span>
													</Tooltip>
													<Input.TextArea
														autoSize={ {
															maxRows : 6,
															minRows : 1
														} }
														className="RAinputMessage"
														maxLength={ 5000 }
														placeholder={ i18n.inputPlaceholder[isRu] }
														tabindex="-1"
														onChange={ (e) => {
															form.setFieldsValue({ messageText: e.target.value })
														} }
													/>
												</span>
											</Form.Item>)
									} }
								</Form.Item>
								<Form.Item
									noStyle
									shouldUpdate
								>
									{ () => {
										return 	(
											<Form.Item
												className="RAmessageFiles"
												getValueFromEvent={ normFile }
												name="messageFiles"
												style={ { display: form.getFieldValue("messageFiles")?.length ? null : "none" } }
												valuePropName="fileList"
											>
												<UploadFile
													removeFromList
													fileList={ form.getFieldValue("messageFiles") }
													listType="text"
													maxCount={ 5 }
													notShow="attachMessageFiles"
													onChangeCustom={ (info) => {
														const files = info.fileList
														form.setFieldsValue({ messageFiles: files })
													} }
												/>
											</Form.Item>
										)
									} }
								</Form.Item>
								<Form.Item
									noStyle
									shouldUpdate
								>
									{ () => {
										return 	(
											<Form.Item name="send">
												<CustomButton
													disabled={ !(form.getFieldValue("messageFiles")?.length || form.getFieldValue("messageText")?.trim()) }
													htmlType="submit"
													loading={ getLoadingSend }
													style={ { float: "right" } }
													type="orange"
												>
													{ i18n.sendMessageTo[isRu] }
												</CustomButton>
											</Form.Item>
										)
									} }
								</Form.Item>
							</Form>
						</Modal>
						<div
							className="send-message"
							onClick={ showModal }
						>
							<svg
								height="18"
								viewBox="0 0 20 18"
								width="20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M19.502 9.375L0.175781 17.998L2.32422 9.375L0.175781 0.751953L19.502 9.375ZM2.01172 2.93945L3.4668 8.7793H15.0879L2.01172 2.93945ZM3.44727 10.0293L2.01172 15.8105L14.9707 10.0293H3.44727Z"
								/>
							</svg>
							<span>
								{ i18n.sendMessageToApplicant[isRu] }
							</span>
						</div>
					</>
				)
					: null
			}
		</>
	)
}

export default SendMessageFromList